import React from 'react';
import Section from '../Images/Section.png';
import HwwRegister from '../Images/HwwRegister.png';
import Hwwselectlead from '../Images/Hwwselectlead.jpg';
import PaymentIcon from '../Images/PaymentIcon.png';
import LeadMangement from '../Images/LeadMangement.png';
import { Fade } from 'react-reveal';

const Section2 = () => {
  return (
    <div>
      <div className='howitwork' style={{backgroundImage:`url(${Section})`, width:'100%',height:'785px'}}>
        <header className="header-design">
          <div className="footer-wave"></div>
        </header>
        <div className="pset">
          <div className="container">
            <div className="listar-map-button">
              <div className="listar-map-button-text" style={{display: 'inline-block', opacity: '1'}}>
                <span className="icon-map2">
                  The Ultimate Lead Management Solution
                </span>
              </div>
            </div>
            <div className="row listar-feature-items">
              
              {/* Card 1 */}
              <Fade bottom delay={0}>
                <div className="col-xs-12 col-sm-6 col-md-3 listar-feature-item-wrapper listar-feature-with-image listar-height-changed">
                  {/* ...Card 1 Content... */}
                  <img alt="Businesses" className="listar-image-icon" src={HwwRegister}/>
                  <div className="listar-feature-content-wrapper" style={{paddingTop: '0px'}}>
                    <div className="listar-feature-item-title listar-feature-counter-added">
                      <span className='howitworkpoint'><span style={{paddingTop: '20px'}}>01</span> Register Your Lead Account </span>
                    </div>
                    <div className="listar-feature-item-excerpt">
                      Get started by setting up your Blaccdot lead management account easily online.
                    </div>
                  </div>
                </div>
              </Fade>

              {/* Card 2 */}
              <Fade bottom delay={200}>
                <div className="col-xs-12 col-sm-6 col-md-3 listar-feature-item-wrapper listar-feature-with-image listar-height-changed">
                  {/* ...Card 2 Content... */}
                  <img alt="Customers" style={{marginBottom: '20px'}} className="listar-image-icon" src={Hwwselectlead}/>
                  <div className="listar-feature-content-wrapper" style={{paddingTop: '0px'}}>
                    <div className="listar-feature-item-title listar-feature-counter-added">
                      <span className='howitworkpoint'><span style={{paddingTop: '20px'}}>02</span> Choose Lead Packages</span>
                    </div>
                    <div className="listar-feature-item-excerpt">
                      Select from flexible lead packages tailored to your business needs and budget.
                    </div>
                  </div>
                </div>
              </Fade>

              {/* Card 3 */}
              <Fade bottom delay={400}>
                <div className="col-xs-12 col-sm-6 col-md-3 listar-feature-item-wrapper listar-feature-with-image listar-height-changed">
                  {/* ...Card 3 Content... */}
                  <img style={{width:'60%',height:'65%'}} alt="Feedback" className="listar-image-icon" src={PaymentIcon}/>
                  <div className="listar-feature-content-wrapper" style={{paddingTop: '0px'}}>
                    <div className="listar-feature-item-title listar-feature-counter-added">
                      <span className='howitworkpoint'><span style={{paddingTop: '20px'}}>03</span>Complete Payment</span>
                    </div>
                    <div className="listar-feature-item-excerpt">
                      Secure payment processing ensures effortless access to premium lead management capabilities.
                    </div>
                  </div>
                </div>
              </Fade>
              
              {/* Card 4 */}
              <Fade bottom delay={600}>
                <div className="col-xs-12 col-sm-6 col-md-3 listar-feature-item-wrapper listar-feature-with-image listar-height-changed">
                  {/* ...Card 4 Content... */}
                  <img alt="Customers" className="listar-image-icon" src={LeadMangement}/>
                  <div className="listar-feature-content-wrapper" style={{paddingTop: '0px'}}>
                    <div className="listar-feature-item-title listar-feature-counter-added">
                      <span className='howitworkpoint'><span style={{paddingTop: '20px'}}>04</span> Leverage Lead Acceleration</span>
                    </div>
                    <div className="listar-feature-item-excerpt">
                      Unlock powerful lead capture, nurturing, scoring, and routing with Blaccdot's intuitive platform.
                    </div>
                  </div>
                </div>
              </Fade>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Section2;
